import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import Ranking from "./Ranking";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Helmet>
        <title>Ranking</title>
        <meta name="description" content="Ranking" />
      </Helmet>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/ranking`} />
        <Route path={`${match.url}/ranking`} component={Ranking} />
      </Switch>
    </div>
  );
}
